import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as featureActions from '../../index';
import {Store} from '@ngrx/store';
import {Observable, of} from 'rxjs';
import * as fromStore from '../../../store';
import {catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { CompanionRuleActions } from '../actions/companion-rule.actions';
import {CompanionService} from '../../../services/companion.service';
import { CompanionRule, Device } from '../companion-rule.model';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import { TranslateService } from '@ngx-translate/core';



@Injectable()
export class CompanionRuleEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private companionService = inject(CompanionService);
  private injector = inject(Injector);


  constructor() {}

  ReadCompanionRuleList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionRuleActionTypes.GetCompanionRuleList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadCompanionRuleList
      };
      return this.companionService.ReadCompanionRuleList(user.otp).pipe(
        map((res: any) => {
          if (res.msg.body) {
            return new featureActions.UpsertCompanionRuleList(res.msg.body);
          } else {
            return new featureActions.NoCompanionRuleList();
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          //   return [new featureActions.GetCompanionRuleListFail(),
          //           new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.GetCompanionRuleListFail()];
        })
      );
    })
  ));
  UpdateCompanionRule$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CompanionRuleActionTypes.UpdateCompanionRule),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateCompanionRule
      };
      const payload = { ...action.payload, otp: user.otp };
      return this.companionService.UpdateCompanionRule(payload).pipe(
        switchMap((res: any) => {
          if (res.result) {
            const msg = action.payload.Event.length === 0 && action.payload.CmpnId.length === 0
              ? this.injector.get(TranslateService).instant('Delete Companion Rule Success')
              : action.payload.RuleId.length === 0
                ? this.injector.get(TranslateService).instant('Add Companion Rule Success')
                : this.injector.get(TranslateService).instant('Update Companion Rule Success');
            return [new featureActions.GetCompanionRuleList(),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg })];
          } else {
            return [new featureActions.UpdateCompanionRuleFail(),
                    new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.msg.body })];
          }
        }),
        catchError((error) => {
          // updateRes.errmsg = error.error.errmsg.body;
          //   return [new featureActions.UpdateCompanionRuleFail(),
          //           new featureActions.UpdateInfoFailAction(updateRes)];
          return [new featureActions.UpdateCompanionRuleFail()];
        })
      );
    })
  ));
}
